// extracted by mini-css-extract-plugin
export default {"productCarousel":"d0-z"};